import React from "react";
import DuplicateQuoteContent from "../components/quotes/duplicate-quote-content";

const DuplicateQuote = () => {
  return <DuplicateQuoteContent />;
};

export default DuplicateQuote;
